import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios, { AxiosResponse } from 'axios';
import { Anagraphic, User } from 'src/models/user.model';
import { toast } from 'react-toastify';
import { ToastError } from '../components/atoms/toast/toast-error';

type InitialState = {
  loading: boolean;
  success: boolean;
  failure: boolean;
  user: User;
};

const INITIAL_STATE: InitialState = {
  loading: false,
  success: false,
  failure: false,
  user: null as unknown as User,
};

export const editAnagraphic = createAsyncThunk(
  'anagraphic/put',
  async (data: { anagraphic: Anagraphic; userId: number }, { rejectWithValue }) => {
    try {
      const response: AxiosResponse<User> = await axios.put(`/api/anagraphic`, data);
      toast(() => ToastError('Anagrafica aggiornata con successo'));

      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

// Methods

const anagraphicSlice = createSlice({
  name: 'anagraphic',
  initialState: INITIAL_STATE,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(editAnagraphic.pending, state => {
        return { ...state, loading: true, success: false, failure: false };
      })
      .addCase(editAnagraphic.fulfilled, (state, action: PayloadAction<User>) => {
        return {
          ...state,
          loading: false,
          success: true,
          failure: false,
          user: action.payload,
        };
      })
      .addCase(editAnagraphic.rejected, state => {
        return { ...state, loading: false, success: false, failure: true };
      });
  },
});

export default anagraphicSlice.reducer;
